export {
  default as ProductRecomendationParticipant
} from './ProductRecomendationParticipantContainer'
export {
  default as ProductRecomendationSku
} from './ProductRecomendationSkuContainer'
export { default as productRecomendationReducer } from './reducer'



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductRecomendation/index.js